"use_strict";

const xnkdwqtcebqffddkqccqwabwbdhkpxec =
{
	values:
	{
		"rules":
		[
			{"id":"r_op_gxx_wash" ,"product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_g_wash"  ,"step":"wash"  },
			{"id":"r_op_gxx_apply","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_g_apply" ,"step":"apply" },
			{"id":"r_op_xgx_wash" ,"product_id":["p21"]            ,"action":"instruction","instruction":"i_op_g_wash"  ,"step":"wash"  },
			{"id":"r_op_xgx_apply","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_g_apply" ,"step":"apply" },
			{"id":"r_op_xxg_wash" ,"product_id":["p37"]            ,"action":"instruction","instruction":"i_op_g_wash"  ,"step":"wash"  },
			{"id":"r_op_xxg_apply","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_g_apply" ,"step":"apply" },
			{"id":"r_op_rxx_wash" ,"product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_r_wash"  ,"step":"wash"  },
			{"id":"r_op_rxx_grind","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_r_grind" ,"step":"grind" },
			{"id":"r_op_rxx_prime","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_r_prime" ,"step":"prime" },
			{"id":"r_op_rxx_apply","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_r_apply" ,"step":"apply" },
			{"id":"r_op_xrx_wash" ,"product_id":["p21"]            ,"action":"instruction","instruction":"i_op_r_wash"  ,"step":"wash"  },
			{"id":"r_op_xrx_grind","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_r_grind" ,"step":"grind" },
			{"id":"r_op_xrx_prime","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_r_prime" ,"step":"prime" },
			{"id":"r_op_xrx_apply","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_r_apply" ,"step":"apply" },
			{"id":"r_op_xxr_wash" ,"product_id":["p37"]            ,"action":"instruction","instruction":"i_op_r_wash"  ,"step":"wash"  },
			{"id":"r_op_xxr_grind","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_r_grind" ,"step":"grind" },
			{"id":"r_op_xxr_prime","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_r_prime" ,"step":"prime" },
			{"id":"r_op_xxr_apply","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_r_apply" ,"step":"apply" },
			{"id":"r_op_bxx_wash" ,"product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_b_wash"  ,"step":"wash"  },
			{"id":"r_op_bxx_grind","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_b_grind" ,"step":"grind" },
			{"id":"r_op_bxx_apply","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_b_apply" ,"step":"apply" },
			{"id":"r_op_xbx_wash" ,"product_id":["p21"]            ,"action":"instruction","instruction":"i_op_b_wash"  ,"step":"wash"  },
			{"id":"r_op_xbx_grind","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_b_grind" ,"step":"grind" },
			{"id":"r_op_xbx_apply","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_b_apply" ,"step":"apply" },
			{"id":"r_op_xxb_wash" ,"product_id":["p37"]            ,"action":"instruction","instruction":"i_op_b_wash"  ,"step":"wash"  },
			{"id":"r_op_xxb_grind","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_b_grind" ,"step":"grind" },
			{"id":"r_op_xxb_apply","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_b_apply" ,"step":"apply" },
			{"id":"r_op_yxx_wash" ,"product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_y_remove","step":"remove"},
			{"id":"r_op_yxx_grind","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_y_grind" ,"step":"grind" },
			{"id":"r_op_yxx_prime","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_y_prime" ,"step":"prime" },
			{"id":"r_op_yxx_apply","product_id":["p31","p33","p34"],"action":"instruction","instruction":"i_op_y_apply" ,"step":"apply" },
			{"id":"r_op_xyx_wash" ,"product_id":["p21"]            ,"action":"instruction","instruction":"i_op_y_remove","step":"remove"},
			{"id":"r_op_xyx_grind","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_y_grind" ,"step":"grind" },
			{"id":"r_op_xyx_prime","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_y_prime" ,"step":"prime" },
			{"id":"r_op_xyx_apply","product_id":["p21"]            ,"action":"instruction","instruction":"i_op_y_apply" ,"step":"apply" },
			{"id":"r_op_xxy_wash" ,"product_id":["p37"]            ,"action":"instruction","instruction":"i_op_y_remove","step":"remove"},
			{"id":"r_op_xxy_grind","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_y_grind" ,"step":"grind" },
			{"id":"r_op_xxy_prime","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_y_prime" ,"step":"prime" },
			{"id":"r_op_xxy_apply","product_id":["p37"]            ,"action":"instruction","instruction":"i_op_y_apply" ,"step":"apply" },

			{"id":"r_op_gxx" , "product_id":["p31","p33","p34"] , "action":"rules" , "rule_ids":["r_op_gxx_wash" , "r_op_gxx_apply" ]                                       },
			{"id":"r_op_xgx" , "product_id":["p21"]             , "action":"rules" , "rule_ids":["r_op_xgx_wash" , "r_op_xgx_apply" ]                                       },
			{"id":"r_op_xxg" , "product_id":["p37"]             , "action":"rules" , "rule_ids":["r_op_xxg_wash" , "r_op_xxg_apply" ]                                       },
			{"id":"r_op_rxx" , "product_id":["p31","p33","p34"] , "action":"rules" , "rule_ids":["r_op_rxx_wash" , "r_op_rxx_grind" , "r_op_rxx_prime" , "r_op_rxx_apply" ] },
			{"id":"r_op_xrx" , "product_id":["p21"]             , "action":"rules" , "rule_ids":["r_op_xrx_wash" , "r_op_xrx_grind" , "r_op_xrx_prime" , "r_op_xrx_apply" ] },
			{"id":"r_op_xxr" , "product_id":["p37"]             , "action":"rules" , "rule_ids":["r_op_xxr_wash" , "r_op_xxr_grind" , "r_op_xxr_prime" , "r_op_xxr_apply" ] },
			{"id":"r_op_bxx" , "product_id":["p31","p33","p34"] , "action":"rules" , "rule_ids":["r_op_bxx_wash" , "r_op_bxx_grind" , "r_op_bxx_apply" ]                    },
			{"id":"r_op_xbx" , "product_id":["p21"]             , "action":"rules" , "rule_ids":["r_op_xbx_wash" , "r_op_xbx_grind" , "r_op_xbx_apply" ]                    },
			{"id":"r_op_xxb" , "product_id":["p37"]             , "action":"rules" , "rule_ids":["r_op_xxb_wash" , "r_op_xxb_grind" , "r_op_xxb_apply" ]                    },
			{"id":"r_op_yxx" , "product_id":["p31","p33","p34"] , "action":"rules" , "rule_ids":["r_op_yxx_wash" , "r_op_yxx_grind" , "r_op_yxx_prime" , "r_op_yxx_apply" ] },
			{"id":"r_op_xyx" , "product_id":["p21"]             , "action":"rules" , "rule_ids":["r_op_xyx_wash" , "r_op_xyx_grind" , "r_op_xyx_prime" , "r_op_xyx_apply" ] },
			{"id":"r_op_xxy" , "product_id":["p37"]             , "action":"rules" , "rule_ids":["r_op_xxy_wash" , "r_op_xxy_grind" , "r_op_xxy_prime" , "r_op_xxy_apply" ] },

			{"id":"r_op_grg" , "answer_id":"q1a4","selection":"grg" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_gxx" , "r_op_xrx" , "r_op_xxg" ] },
			{"id":"r_op_grb" , "answer_id":"q1a4","selection":"grb" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_gxx" , "r_op_xrx" , "r_op_xxb" ] },
			{"id":"r_op_rrr" , "answer_id":"q1a4","selection":"rrr" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_rxx" , "r_op_xrx" , "r_op_xxr" ] },
			{"id":"r_op_bgb" , "answer_id":"q1a4","selection":"bgb" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_bxx" , "r_op_xgx" , "r_op_xxb" ] },
			{"id":"r_op_brg" , "answer_id":"q1a4","selection":"brg" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_bxx" , "r_op_xrx" , "r_op_xxg" ] },
			{"id":"r_op_brb" , "answer_id":"q1a4","selection":"brb" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_bxx" , "r_op_xrx" , "r_op_xxb" ] },
			{"id":"r_op_bbb" , "answer_id":"q1a4","selection":"bbb" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_bxx" , "r_op_xbx" , "r_op_xxb" ] },
			{"id":"r_op_byb" , "answer_id":"q1a4","selection":"byb" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_bxx" , "r_op_xyx" , "r_op_xxb" ] },
			{"id":"r_op_yyy" , "answer_id":"q1a4","selection":"yyy" , "product_id":["p31","p33","p34","p21","p37"] , "action":"rules" , "rule_ids":[ "r_op_yxx" , "r_op_xyx" , "r_op_xxy" ] },

			{
				"id": "r_neues_boot_A",
				"answer_id": "q1a1",
				"product_id": ["p31","p33","p34","p37"],
				"action": "instruction",
				"instruction": "i_4layersPrimer117 , i_apply_antifouling",
			},
			{
				"id": "r_neues_boot_B",
				"answer_id": "q1a1",
				"product_id": ["p21","p23"],
				"action": "instruction",
				"instruction": "i_4layersPrimer117 , i_biozidfreie_beschichtung_auftragen",
			},
			{
				"id": "r_neues_boot_C",
				"answer_id": "q1a1",
				"product_id": "pBCE",
				"action": "instruction",
				"instruction": "i_4layersPrimer117 , i_TieCoat , i_BioCleanEco",
			},
			{
				"id": "r_schlechter_zustand_A",
				"answer_id": "q1a2",
				"product_id": ["p31","p33","p34","p37"],
				"action": "instruction",
				"instruction": "i_altes_antifouling_komplett_entfernen , i_4layersPrimer117 , i_apply_antifouling",
			},
			{
				"id": "r_schlechter_zustand_B",
				"answer_id": "q1a2",
				"product_id": ["p21","p23"],
				"action": "instruction",
				"instruction": "i_altes_antifouling_komplett_entfernen , i_4layersPrimer117 , i_biozidfreie_beschichtung_auftragen"
			},
			{
				"id": "r_schlechter_zustand_C",
				"answer_id": "q1a2",
				"product_id": "pBCE",
				"action": "instruction",
				"instruction": "i_altes_antifouling_komplett_entfernen , i_4layersPrimer117 , i_TieCoat , i_BioCleanEco"
			},
			{
				"id": "r_guter_zustand_p23",
				"answer_id": "q1a4",
				"product_id": "p23",
				"action": "instruction",
				"instruction": "i_schleim_entfernen , i_anschleifen , i_nochmal_waschen , i_1layerPrimer015 , i_biozidfreie_beschichtung_auftragen",
			},
			{
				"id": "r_guter_zustand_pBCE",
				"answer_id": "q1a4",
				"product_id": "pBCE",
				"action": "instruction",
				"instruction": "i_schleim_entfernen , i_anschleifen , i_nochmal_waschen , i_2layersTieCoat , i_2layersBCE",
			},
			{
				"id": "r_rumpf_aluminium",
				"answer_id": "q2a4",
				"product_id": ["p31", "p33" , "p37"],
				"action": "exclude"
			},
			{
				"id": "r_salzwasser_50",
				"answer_id": "q3a1",
				"product_id": ["p31","p37"],
				"action": "percent",
				"value": 50
			},
			{
				"id": "r_salzwasser_150",
				"answer_id": "q3a1",
				"product_id": "p33",
				"action": "percent",
				"value": 150
			},
			{
				"id": "r_sueswasser_150",
				"answer_id": "q3a2",
				"product_id": ["p31", "p33"],
				"action": "percent",
				"value": 150
			},
			{
				"id": "r_sueswasser_50",
				"answer_id": "q3a2",
				"product_id": "p34",
				"action": "percent",
				"value": 50
			},
			{
				"id": "r_brackwasser_150",
				"answer_id": "q3a3",
				"product_id": "p33",
				"action": "percent",
				"value": 150
			},
			{
				"id": "r_brackwasser_50",
				"answer_id": "q3a3",
				"product_id": ["p31","p34","p37","p21","p23","pBCE"],
				"action": "percent",
				"value": 50
			},
			{
				"id": "r_70knoten",
				"answer_id": "q4a2",
				"product_id": ["p31","p33","p34","p21","pBCE"],
				"action": "exclude"
			},
			{
				"id": "r_daily_150",
				"answer_id": "q5a1",
				"product_id": ["p31","p33","p34","p37","pBCE"],
				"action": "percent",
				"value": 150
			},
			{
				"id": "r_weekly_125",
				"answer_id": "q5a2",
				"product_id": ["p33","pBCE"],
				"action": "percent",
				"value": 125
			},
			{
				"id": "r_monthly_50",
				"answer_id": "q5a3",
				"product_id": ["p31","p34","p21","p23"],
				"action": "percent",
				"value": 50
			},
			{
				"id": "r_monthly_75",
				"answer_id": "q5a3",
				"product_id": "p37",
				"action": "percent",
				"value": 75
			},
			{
				"id": "r_monthly_150",
				"answer_id": "q5a3",
				"product_id": "p33",
				"action": "percent",
				"value": 150
			},
			{
				"id": "r_holland",
				"answer_id": "q7a1",
				"product_id": ["p31","p33","p34","p37"],
				"action": "exclude"
			},
			{
				"id": "r_starker_bewuchs",
				"answer_id": "q7a2",
				"product_id": ["p31","p34","p37","p21","p23"],
				"action": "exclude"
			},
			{
				"id": "r_boot_ganzes_jahr_im_wasser",
				"answer_id": "q7a3",
				"product_id": ["p31", "p34", "p37", "p21", "p23"],
				"action": "exclude"
			},
			{
				"id": "r_tropisch",
				"answer_id": "q7a4",
				"product_id": ["p31","p37","p21","p23"],
				"action": "exclude"
			},
			{
				"id": "r_liegeplatz_schlammig",
				"answer_id": "q7a5",
				"product_id": ["p31","p33","p34","p21","pBCE"],
				"action": "exclude"
			},
			{
				"id": "r_biozidfrei",
				"answer_id": "q7a6",
				"product_id": ["p31","p33","p34","p37"],
				"action": "exclude"
			},
			{
				"id": "r_trailerboot",
				"answer_id": "q7a7",
				"product_id": ["p31","p33","p34","p21","pBCE"],
				"action": "exclude"
			},
			{
				"id": "r_selbstpolierend_verboten",
				"answer_id": "q7a8",
				"product_id": ["p31","p33","p34","p21","pBCE"],
				"action": "exclude"
			},
			{
				"id": "r_allgemein_A",
				"general": true,
				"product_id": ["p31","p33","p34","p37","p21","p23"],
				"action": "instruction",
				"instructions": ["i_allgemein_A_1" , "i_allgemein_A_2" , "i_allgemein_A_3"]
			},
			{
				"id": "r_allgemein_B",
				"general": true,
				"product_id": ["pBCE"],
				"action": "instruction",
				"instructions": ["i_allgemein_B_prime" , "i_allgemein_B_apply"]
			}
		]
	}
}

// @ts-ignore
window.xnkdwqtcebqffddkqccqwabwbdhkpxec = xnkdwqtcebqffddkqccqwabwbdhkpxec;
